/**
 * Asynchronously loads the component for TwoFactorLoginPage
 */

import { lazyLoad } from 'utils/loadable';

export const TwoFactorLoginPage = lazyLoad(
  () => import('./index'),
  module => module.TwoFactorLoginPage,
);
